import { TYPES } from "./helpers";
import { StepHeader } from "./ProgressBar";

export default function StepType({ type, setType }) {
  return (
    <div className="space-y-12 animate-[fade-in-up_500ms_ease-out_both]">
      <StepHeader sub="Dit helpt ons de juiste marktprijzen te vergelijken.">
        Over welk type offerte gaat het?
      </StepHeader>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
        {TYPES.map((t) => {
          const Icon = t.icon;
          const active = type === t.id;
          return (
            <button
              key={t.id}
              data-testid={`type-${t.id.replace(/[^a-zA-Z]/g, "-").toLowerCase()}`}
              onClick={() => setType(t.id)}
              className={`text-left p-7 rounded-oc border transition-all bg-white hover:-translate-y-0.5 hover:shadow-oc-card-hover ${
                active
                  ? "border-oc-primary ring-2 ring-oc-primary/15 shadow-oc-card-hover"
                  : "border-oc-border"
              }`}
            >
              <div
                className={`w-11 h-11 rounded-xl flex items-center justify-center ${
                  active ? "bg-oc-primary text-white" : "bg-oc-subtle text-oc-primary"
                }`}
              >
                <Icon className="w-5 h-5" />
              </div>
              <h3 className="font-display font-semibold mt-5 text-oc-primary text-[17px] leading-snug">
                {t.id}
              </h3>
              <p className="text-oc-textSecondary text-[14px] mt-1.5 leading-relaxed">{t.desc}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
